import * as React from "react";
const SvgFiRrWastePollution = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-waste-pollution_svg__a)">
      <path
        fill="#062147"
        d="M24 5v13a1 1 0 1 1-2 0V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v13a1 1 0 1 1-2 0V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-.049 18.308a1 1 0 0 1-1.259.643c-.646-.209-1.249-.614-1.732-1.138A4.38 4.38 0 0 1 18 24a3.97 3.97 0 0 1-3-1.382A3.97 3.97 0 0 1 12 24a3.97 3.97 0 0 1-3-1.382A3.97 3.97 0 0 1 6 24a4.38 4.38 0 0 1-2.96-1.187c-.483.523-1.087.929-1.732 1.138a1 1 0 1 1-.615-1.903c.573-.186 1.147-.767 1.365-1.382a1 1 0 0 1 1.884 0c.265.747 1.169 1.333 2.058 1.333 1.103 0 2-.897 2-2v-7c0-.266.105-.52.293-.707.132-.133 1.36-1.293 3.707-1.293s3.575 1.16 3.707 1.293a1 1 0 0 1 .293.707v7c0 1.103.897 2 2 2 .889 0 1.793-.586 2.058-1.333a1 1 0 0 1 1.884 0c.218.615.792 1.196 1.365 1.382a1 1 0 0 1 .644 1.259zM14 20v-6.501c-.35-.208-1.014-.499-2-.499s-1.646.289-2 .501V20c0 1.103.897 2 2 2s2-.897 2-2m4.128-4.469a1.002 1.002 0 0 0 1.301-.557A8 8 0 0 0 20 11.999c0-4.411-3.589-8-8-8S4 7.589 4 12c0 .983.177 1.944.526 2.857a1 1 0 1 0 1.867-.715 6.006 6.006 0 0 1 5.606-8.143 6.006 6.006 0 0 1 5.571 8.23 1 1 0 0 0 .557 1.301z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-waste-pollution_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWastePollution;
